import React, { useState } from "react";
import "./Sidebar.css";
import { RiArrowDropDownLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

export default function Sidebar() {
    const [companyOpen, setCompanyOpen] = useState(true);
    const [userOpen, setUserOpen] = useState(true);
    const [deviceOpen, setDeviceOpen] = useState(false);

    const [selected, setSelected] = useState("Department");
    const navigate = useNavigate();

    return (
        <aside className="sidebar">

            {/* Company Master */}

            <div
                className="sidebar-section-header"
                onClick={() => setCompanyOpen(!companyOpen)}
            >
                <span>Company Master</span>

                <span className="sidebar-arrow">
                    <RiArrowDropDownLine
                        className={companyOpen ? "arrow-open" : ""}
                    />
                </span>
            </div>

            {companyOpen && (
                <div className="sidebar-list">

                    <div
                        className={`sidebar-item ${selected === "Department" ? "active" : ""
                            }`}
                        onClick={() => {
                            setSelected("Department");
                            navigate("/admin/desktop/department-master");
                        }}
                    >
                        Department
                    </div>

                    <div
                        className={`sidebar-item ${selected === "Location" ? "active" : ""
                            }`}
                        onClick={() => {
                            setSelected("Location");
                            navigate("/admin/desktop/location-master");
                        }}
                    >
                        Location
                    </div>

                    <div
                        className={`sidebar-item ${selected === "Holiday" ? "active" : ""
                            }`}
                        onClick={() => {
                            setSelected("Holiday");
                            navigate("/admin/desktop/holiday-master");
                        }}
                    >
                        Holiday
                    </div>

                    <div
                        className={`sidebar-item ${selected === "Shift" ? "active" : ""
                            }`}
                        onClick={() => {
                            setSelected("Shift");
                            navigate("/admin/desktop/shift-master");
                        }}
                    >
                        Shift
                    </div>

                    <div
                        className={`sidebar-item ${selected === "Grace Time" ? "active" : ""
                            }`}
                        onClick={() => {
                            setSelected("Grace Time");
                            navigate("/admin/desktop/grace-time-master");
                        }}
                    >
                        Grace Time
                    </div>

                </div>
            )}

            {/* User Master */}

            <div
                className="sidebar-section-header"
                onClick={() => setUserOpen(!userOpen)}
            >
                <span>User Master</span>

                <span className="sidebar-arrow">
                    <RiArrowDropDownLine
                        className={userOpen ? "arrow-open" : ""}
                    />
                </span>
            </div>

            {userOpen && (
                <div className="sidebar-list">

                    <div
                        className={`sidebar-item ${selected === "User List" ? "active" : ""
                            }`}
                        onClick={() => {
                            setSelected("User List")
                            navigate("/admin/desktop/userlist-master")
                        }}
                    >
                        User List
                    </div>

                    <div
                        className={`sidebar-item ${selected === "Designation" ? "active" : ""
                            }`}
                        onClick={() => {
                            setSelected("Designation")
                            navigate("/admin/desktop/designation-master");
                        }}


                    >
                        Designation
                    </div>

                </div>
            )}

            {/* Device Setting */}

            <div
                className="sidebar-section-header"
                onClick={() => setDeviceOpen(!deviceOpen)}
            >
                <span>Device Setting</span>

                <span className="sidebar-arrow">
                    <RiArrowDropDownLine
                        className={deviceOpen ? "arrow-open" : ""}
                    />
                </span>
            </div>

            {deviceOpen && (
                <div className="sidebar-list">
                    <div
                        className={`sidebar-item ${selected === "Device Master" ? "active" : ""
                            }`}
                        onClick={() => {
                            setSelected("Device Master");
                            navigate("/admin/desktop/device-master");
                        }}
                    >
                        Device Master
                    </div>
                </div>
            )}


            {/* Shift Roster */}

            <div
                className="sidebar-section-header"
                onClick={() => {
                    setSelected("Shift Roster");
                    navigate("/admin/desktop/shift-roster");
                }}
            >
                <span>Shift Roster</span>
            </div>

            {/* Week Off Roster */}

            <div
                className="sidebar-section-header"
                onClick={() => {
                    setSelected("Week Off Roster");
                    navigate("/admin/desktop/week-off-roster");
                }}
            >
                <span>Week Off Roster</span>
            </div>

            {/* Report */}

            <div
                className={`sidebar-section-header`}
                onClick={() => {
                    setSelected("Report");
                    navigate("/admin/desktop/report");
                }}
            >
                <span>Report</span>
            </div>

            {/* Theme Settings */}

            <div
                className="sidebar-section-header"
                onClick={() => {
                    setSelected("Theme Settings");
                    navigate("/admin/desktop/theme-settings");
                }}
            >
                <span>Theme Settings</span>
            </div>





        </aside>
    );
}